import React, { Component } from 'react';
import { firebaseRef } from '../firebase.js';
import { withRouter } from 'react-router-dom';
import Historycomponent from './Historycomponent';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

var historyArray = [];
class Historypatient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
    };
  }

  componentDidMount(){
    var that=this;
    var userId = this.props.match.params.user;
    var doctor = this.props.match.params.doctor;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+userId+'/buttons');
    refMain.on('child_added', function(datasnapShot){
      if (datasnapShot) {
        var data = datasnapShot.val();
        var history = {"key": datasnapShot.key,
        "order": data.order,
        "pArray": data.pArray,
        "ocrt": data.ocrt,
        "p1Check": data.p1Check,
        "main": data.main,
        "mainAfter": data.mainAfter,
        "date": data.date,
        "comment": data.comment,
      };
        historyArray.push(history);
      }
      that.setState({ loader: false });
    });
    refMain.on('child_removed', function(datasnapShot){
      var removeIndex = historyArray.map(function(item) { return item.key; }).indexOf(datasnapShot.key);
      historyArray.splice(removeIndex,1);
      that.forceUpdate();
    });
    this.setState({ loader: false });
  }

  render(){
    const history = historyArray.map(d => (<Historycomponent key={d.key} id={d.key} mainAfter={d.mainAfter} order={d.order} p1Check={d.p1Check} pArray={d.pArray} ocrt={d.ocrt} main={d.main} date={d.date} comment={d.comment} />));
    return (
      <div style={{marginBottom: 20, marginTop: 20}} align="center">
      {this.state.loader ? (
        <div><p>Loading...</p></div>
      ):(
        historyArray.length > 0 ? (
            <ReactCSSTransitionGroup transitionName="example"  transitionEnterTimeout={1000} transitionLeaveTimeout={300}>
              {history}
            </ReactCSSTransitionGroup>
        ):(
          <h3>{`There's No History`}</h3>
        )


      )
    }
    </div>
  );
  }
}

export default withRouter(Historypatient);



// WEBPACK FOOTER //
// ./src/routes/Paitent/History.js